import { Box, Typography, styled } from "@mui/material"

export const TitleContainerBox = styled(Box)({
  display: "flex",
  gap: "16px",
  alignItems: "center",
  margin: "1.25rem 0 1.5rem",
})

export const Title = styled(Typography)({
  fontSize: "1.5rem",
  fontWeight: 600,
  color: "#353535",
  fontFamily: '"Inter", sans-serif',
  position: "relative",
})
